<template>
  <DropdownComponent class="user-language">
    <template #default>
      <InputComponent :label="$t('language')">
        <template #default>
          <div class="elder-input__element row middle">
            <img :src="`/images/flags/${value}.svg`" :alt="i18n[value]" width="20" />
            <div class="ml-2">{{ i18n[value] }}</div>
            <FontAwesomeIcon class="user-language__icon" :icon="['fal', 'angle-down']" size="lg" />
          </div>
        </template>
      </InputComponent>
    </template>
    <template #dropdown>
      <ButtonComponent
        v-for="lang in enums.Languages.filter(i => Object.keys(Languages).includes(i.value))"
        :key="lang.value"
        :label="lang.value"
        @click="$emit('input', lang.value)"
      >
        <template #icon>
          <img :src="`/images/flags/${lang.value}.svg`" :alt="i18n[lang.value]" width="20" />
        </template>
        <template #label>
          {{ i18n[lang.value] }}
        </template>
      </ButtonComponent>
    </template>
  </DropdownComponent>
</template>

<script>
import { mapState } from 'vuex'

import { DropdownComponent } from 'vue-elder-dropdown'
import { InputComponent } from 'vue-elder-input'

const Languages = {
  nb: 'Norsk',
  sv: 'Svenska',
  en: 'English',
  da: 'Dansk',
  fr: 'Français',
  de: 'Deutsch',
}

export { Languages }
export default {
  props: {
    value: String,
  },
  data() {
    return {
      i18n: Languages,
      Languages,
    }
  },
  computed: {
    ...mapState(['enums']),
  },
  components: {
    DropdownComponent,
    InputComponent,
  },
}
</script>

<style lang="scss">
.user-language {
  .elder-dropdown__trigger {
    display: initial;
  }

  &__icon {
    position: absolute;
    right: 1.1rem;
    color: inherit;
    opacity: 0.5;
    pointer-events: none;
  }
}
</style>
